import ScrollTop from "../../Components/Buttons/ScrollTop";
import FamousUniversity from "../../Components/ExamPreparationCards/FamousUniversity";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import PracticePaperCompPage from "../../Components/ExamPreparationCards/PracticePaperCompPage";
import HotCoursesHelp from "../../Components/ExamPreparationCards/HotCoursesHelp";
import Certificate from "../../Components/ExamPreparationCards/Certificate";
import BonusSection from "../../Components/BonusSection";
import StudentStories from "../../Components/StudentStories";
import ExamReadMoreSection from "../../Components/ExamReadMoreSection";
import CommonBanner from "../../Components/ExamPreparationCards/CommonBanner";
import Page from "../Metadata/Page";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const PracticePapers = () => {
  const subCategoryId = "67b58250fa3a63e9ddb9218f";
  const categoryId = "67b57f038a01c99610fc51b2";


  const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Practice Papers"},
  ]

  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <CommonBanner subCategoryId={subCategoryId} />
      <SiteReviews />
      <PracticePaperCompPage />
      <HotCoursesHelp />
      <FamousUniversity />
      <Certificate />
      <BonusSection subCategoryId={subCategoryId} />
      <ExamReadMoreSection subCategoryId={subCategoryId} />
      <StudentStories />
      <ScrollTop />
    </>
  );
};

export default PracticePapers;
